import type { UcFormatGridSection } from '../../../lib/useCaseQueries';
import { UseCaseBand, UseCaseMedia, UseCaseSceneSlug } from '../primitives';
import { UseCaseSectionHead } from '../UseCaseSectionHead';

type UcFormatGridSectionProps = {
  data: UcFormatGridSection;
  tone: 'light' | 'dark';
};

export function UcFormatGridSection({ data, tone }: UcFormatGridSectionProps) {
  const heading =
    data.heading || data.headingAccent ? (
      <>
        {data.heading}
        {data.headingAccent && (
          <>
            {data.heading ? ' ' : null}
            <em>{data.headingAccent}</em>
          </>
        )}
      </>
    ) : undefined;

  return (
    <UseCaseBand tone={tone} id="formats" className="uc-format-grid">
      <UseCaseSceneSlug sceneNumber={data.sceneNumber} sceneLabel={data.sceneLabel} />
      {(heading || data.subheading) && (
        <UseCaseSectionHead heading={heading} subheading={data.subheading} />
      )}
      {data.cards && data.cards.length > 0 && (
        <div className="uc-reel-grid reveal">
          {data.cards.map((card) => {
            const hideTag =
              card.tag && card.title && card.tag.trim().toLowerCase() === card.title.trim().toLowerCase();

            return (
              <article key={card.title} className="uc-format-card">
                <div className="uc-format-art">
                  {card.image ? (
                    <UseCaseMedia
                      image={card.image}
                      alt={card.image.alt ?? card.title}
                      width={800}
                      sizes="(max-width: 768px) 100vw, 50vw"
                    />
                  ) : (
                    <div className="uc-format-placeholder" aria-hidden="true" />
                  )}
                  <div className="uc-format-grad" aria-hidden="true" />
                  <div className="uc-format-meta">
                    {card.tag && !hideTag && <div className="uc-format-tag">{card.tag}</div>}
                    <h3 className="uc-format-title">{card.title}</h3>
                    <p className="uc-format-desc">{card.description}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </UseCaseBand>
  );
}
